module.exports = __webpack_public_path__ + "static/media/hero-mobile.fd8af285.svg";